/**
 * Inject a <style> block once per unique id into <head>.
 * Safe to call multiple times -- subsequent calls are no-ops.
 */
const injected = new Set<string>();

export function injectStyles(id: string, css: string): void {
  if (typeof document === "undefined") return;
  if (injected.has(id)) return;
  injected.add(id);
  const style = document.createElement("style");
  style.setAttribute("data-sf", id);
  style.textContent = css;
  document.head.appendChild(style);
}
